const mutations = {
  onGet (state, payload) {
    let data = payload.response.data.data
    payload.event.context.tests = data.data
    payload.event.context.loadingTable = false
    payload.event.context.options.totalItems = data.total
    payload.event.context.options.page = data.current_page
  },
  onGetById (state, payload) {
    let data = payload.response.data.data
    let sections = payload.response.data.data.sections
    payload.event.context.loading = false
    payload.event.context.show = true
    payload.event.context.test.name = data.name
    payload.event.context.test.country = data.country.id
    let types = []
    data.unitTypes.forEach(type => {
      types.push(type.id)
    })
    let sites = []
    data.sites.forEach(site => {
      sites.push(site.id)
    })
    payload.event.context.test.unitTypes = types
    payload.event.context.test.sites = sites
    payload.event.context.sections = sections
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.get()
  },
  onDeleteQuestion (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.get()
  },
  onDeleteSection (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.get()
  },
  onCustomQuestionnaires (state, payload) {
    payload.event.context.customs = payload.response.data.data
  },
  onQuestionnaireDefault (state, payload) {
    payload.event.context.loadingTemplate = false
    payload.event.context.templateQuestionnaire = payload.response.data.data
  }
}

export default mutations